import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import { withCapoeiraSportState } from 'src/ver2/context';
import { Button } from 'antd';

import SparksLayer from 'src/ver2/pages/stats/components/sparks';

import './style.css';

/**
  Это маленький список кнопочек управления
 */

// ===== ВНЕШНИЙ ФЛАГ: показывать «огонь» (искры) позади картинки shufic =====
const SHUFIC_FIRE = false;


const LITTLE_THINGS = {
    'donate': {
        title: 'поддержка проекта',
        imgSrc: "/../images/ver2/shark.png",
        linkTo: '/shop/4'
    },
    'island': {
        title: 'online квест остров',
        imgSrc: "/../images/ver2/IslandMain.png",
        linkTo: '/island/1'
    },
    'fkcaccred': {
        title: 'оплата членства',
        imgSrc: "/../images/ver2/fkr_logo.png",
        linkTo: '/fkraccred'
    },
    'raiting': {
        title: 'лидеры регионов',
        imgSrc: "/../images/ver2/raiting.png",
        linkTo: '/seasonresult/russia'
    },
    'zalslavy': {
        title: 'Зал Славы',
        imgSrc: "/../images/ver2/scores/stuff/kubok_2025_b1.png",
        linkTo: '/absolutes'
    },
    'pumcs': {
        title: 'HALLOWEEN 2024',
        imgSrc: "/../images/ver2/pump.png",
        linkTo: '/article/22'
    },
    'shufic': {
        title: 'Перевернули!',
        imgSrc: "/../images/ver2/shufic.png",
        linkTo: '/article/31'
    },
    'shirts': {
        title: 'форма SoForca',
        imgSrc: "/../images/ver2/form.png",
        linkTo: '/shop/11'
    }
}

class NewsSomePlashka extends PureComponent {

    // constructor(props) {
    //     super(props);
    // }

    state = {
        icons: [
            // 'donate', 'island', 'fkcaccred', 'raiting'
             'zalslavy', 'shufic', 'donate', 'fkcaccred'
        ],
        shuficCount: 0
    };

    componentDidMount = async () => {
        const { client } = this.props;
        if (!client) return;
        if (!this.state.icons.find(x => x === 'shufic')) return;

        try {
            const stats = await client.getStatistics('["shufic"]', null, null, 1, 1);
            // при сбое запроса клиент (standartDataResult) возвращает пустой МАССИВ,
            // а не объект — тогда acNotFinished === undefined. Защищаемся от этого.
            const acNotFinished = (stats && !Array.isArray(stats) && stats.acNotFinished) || [];
            this.setState({ shuficCount: acNotFinished.length });
        } catch (e) {
            // счётчик 'shufic' не критичен: при ошибке просто оставляем 0
            console.log('shufic stats error:', e && e.message);
        }
    }

    OneLittleThing = ({ iconKey }) => {
        const { upperStyle } = this.props;
        const { height } = upperStyle;

        // находим 

        const compHeight = height * 0.9;
        const width = compHeight * 0.667;

        const { title, imgSrc, linkTo } = LITTLE_THINGS[iconKey];

        // у картинки shufic (когда SHUFIC_FIRE = true) сзади рисуем «огонь»
        const isShuficFire = (iconKey === 'shufic' && SHUFIC_FIRE);

        const topStyle = { width, height: width, minHeight: width };
        const imgSide = width * 0.95;                  // размер самой картинки (img шириной 95%)
        const fireW = Math.round(width);               // зона огня не шире колонки (чтобы не наезжать на соседей)
        const fireH = Math.round(width * 1.5);         // огонь растёт выше картинки

        const topContent = (isShuficFire)
            ? <div style={{ ...topStyle, position: 'relative' }} className='slider_some_plashka_one_top'>
                <div className='shufic_fire_wrap' style={{
                    position: 'absolute',
                    left: 0,
                    bottom: 0,
                    width: fireW,
                    height: fireH,
                    zIndex: 0,
                    pointerEvents: 'none'
                }}>
                    <SparksLayer
                        width={fireW}
                        height={fireH}
                        rectWidth={imgSide}
                        rectHeight={imgSide}
                        marginBottom={0}
                    />
                </div>
                <img src={imgSrc} style={{ position: 'relative', zIndex: 1 }} />
            </div>
            : <div style={topStyle} className='slider_some_plashka_one_top'>
                <img src={imgSrc} />
            </div>;

        return <Link key={`sspno_${iconKey}`} to={linkTo}>
            <div style={{ width, height: compHeight }} className='slider_some_plashka_one'>
                {topContent}
                <div className='slider_some_plashka_one_bottom'>
                    <span>
                        {(iconKey === 'shufic' && this.state.shuficCount) ? `Перевернули! ${this.state.shuficCount} человек ` : title}
                    </span>
                </div>
            </div>
        </Link>
    }

    render() {

        const { upperStyle, iamuser } = this.props;

        const { width, height } = upperStyle;
        const { icons } = this.state;

        // для shufic-огня разрешаем выходить за границы плашки вверх
        const showFire = (SHUFIC_FIRE && icons.indexOf('shufic') !== -1);

        console.log('OneLittleThing', { iamuser })

        return <div style={{ width, height, overflow: showFire ? 'visible' : 'hidden' }} className='slider_some_plashka'>
            {icons.map(icon => <this.OneLittleThing key={icon} iconKey={icon} />)}
            {(iamuser && iamuser.SchoolId === 1) ? <this.OneLittleThing key={'shirts'} iconKey={'shirts'} /> : null}
        </div>
    }

    // render2() {

    //     const { ImgPart, Title, Text, LinkTo, upperStyle, maxWidth = null, special } = this.props;

    //     const { width, height } = upperStyle;

    //     const { whoOnIsland, whoPassed } = this.state;

    //     if (special) {
    //         const { showInfoModal } = this.props;
    //         return <div style={{ width, height }} className='slider_some_plashka'>
    //             <Link to={LinkTo}>
    //                 <div style={{ width: maxWidth || height, minWidth: maxWidth || height, height: maxWidth || height }} className='slider_some_plashka_left'>
    //                     {ImgPart}
    //                 </div>
    //             </Link>
    //             <div className='slider_some_plashka_right'>
    //                 <Link to={LinkTo}>
    //                     <div className='slider_some_plashka_right_title'>
    //                         {Title}
    //                     </div>
    //                 </Link>
    //                 <Link to={LinkTo}>
    //                     <div className='slider_some_plashka_right_text'>
    //                         {Text}
    //                     </div>
    //                 </Link>
    //                 {
    //                     (whoPassed && whoOnIsland) &&
    //                     <div className='slider_some_plashka_right_text'>
    //                         {`ИГРАЮТ: ${whoOnIsland.length} / ПРОШЛИ: ${whoPassed.length}`}
    //                     </div>
    //                 }
    //                 {
    //                     (whoPassed && whoOnIsland) &&
    //                     <div className='slider_some_plashka_right_text' onClick={() => {
    //                         showInfoModal({ type: 'personsList', Persons: whoPassed })
    //                     }}>
    //                         <Button type='primary' >КТО ПРОШЕЛ?</Button>
    //                     </div>
    //                 }
    //             </div>
    //         </div>
    //     }

    //     return <Link to={LinkTo}>
    //         <div style={{ width, height }} className='slider_some_plashka'>
    //             <div style={{ width: maxWidth || height, minWidth: maxWidth || height, height: maxWidth || height }} className='slider_some_plashka_left'>
    //                 {ImgPart}
    //             </div>
    //             <div className='slider_some_plashka_right'>
    //                 <div className='slider_some_plashka_right_title'>
    //                     {Title}
    //                 </div>
    //                 <div className='slider_some_plashka_right_text'>
    //                     {Text}
    //                 </div>
    //             </div>
    //         </div>
    //     </Link>
    // }

}

export default withCapoeiraSportState('client, iamuser, showInfoModal')(NewsSomePlashka);